<template>
  <div class="gmf-recent-images-grid-wrapper gmf-context">
    <CustomerImage v-for="comment of comments" :key="comment.id" :comment="comment" :useInViewport="false" />
  </div>
</template>

<style>
.gmf-recent-images-grid {
  container-type: inline-size;
}

.gmf-recent-images-grid-wrapper {
  display: grid;
  gap: calc(var(--gmf-object-spacing) / 2);
  grid-template-columns: repeat(7, 1fr);
}

.gmf-recent-images-grid-wrapper .gmf-customer-image:nth-child(n + 8) {
  display: none;
}

@container (max-width: 800px) {
  .gmf-recent-images-grid-wrapper {
    grid-template-columns: repeat(5, 1fr);
  }
  .gmf-recent-images-grid-wrapper .gmf-customer-image:nth-child(n + 6) {
    display: none;
  }
}

@container (max-width: 700px) {
  .gmf-recent-images-grid-wrapper {
    grid-template-columns: repeat(4, 1fr);
  }
  .gmf-recent-images-grid-wrapper .gmf-customer-image:nth-child(n + 5) {
    display: none;
  }
}

@container (max-width: 579px) {
  .gmf-recent-images-grid-wrapper {
    grid-template-columns: repeat(3, 1fr);
  }
  .gmf-recent-images-grid-wrapper .gmf-customer-image:nth-child(n + 4) {
    display: block;
  }
  .gmf-recent-images-grid-wrapper .gmf-customer-image:nth-child(n + 7) {
    display: none;
  }
}
</style>

<script>
import callApi from '@/utils/callApi';
import CustomerImage from '@/components/CustomerImage'
import elSize from '@/utils/mixins/elSize';
import state from '@/state';

export default {
  name: 'RecentImagesGrid',
  props: ['compactMobileView'],
  mixins: [elSize],
  components: {
    CustomerImage,
  },
  data () {
    return {
      comments: [],
      observer: null
    };
  },
  methods: {
    async fetchRecentImages() {
      const query = new URLSearchParams({
        'take': 8,
        'order': 'created.desc',
        'has_images': 1,
        'reply_depth': 0,
        'no_count': 1,
      });

      if (! state.merchantConfig?.widgets?.comments?.useNewSearch) {
        query.append('max_age_days', 500);
      }

      const res = await callApi('GET', state.commentSearchEndpoint + '?' + query.toString());
      const { comments } = await res.json();

      this.comments = comments.sort(() => Math.random() - 0.5);
    }
  },
  mounted () {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.fetchRecentImages();
          this.observer.disconnect();
        }
      });
    }, {
      threshold: 0.1
    });

    this.observer.observe(this.$el);
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>
